// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09b6399a","239":"9d95abe3","453":"d092d27b","455":"33dc79cf"}[chunkId] + ".chunk.js";
};